import { render, staticRenderFns } from "./SystemSettingsSystemRetrictedIpAddress.vue?vue&type=template&id=0a94467a&"
import script from "@/scripts/modal/systemSettingsSystemRetrictedIpAddress.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/systemSettingsSystemRetrictedIpAddress.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports